import { render } from "./Paywall.vue?vue&type=template&id=56841c54"
import script from "./Paywall.vue?vue&type=script&lang=js"
export * from "./Paywall.vue?vue&type=script&lang=js"

import "./Paywall.vue?vue&type=style&index=0&id=56841c54&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__